<template>
  <div>
    <div class="the-navbar__user-meta flex items-center" v-if="user && userInfo">
      <div class="text-right leading-tight hidden sm:block">
        <p class="font-semibold">{{ userInfo.displayName }}</p>
        <small>{{ userInfo.jobTitle }} - {{ currentProject }}</small>
      </div>

      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <div class="con-img ml-3">
          <img
            v-if="userInfo.photoURL"
            key="onlineImg"
            :src="userInfo.photoURL"
            alt="user-img"
            width="40"
            height="40"
            class="rounded-full shadow-md cursor-pointer block"
          />
          <span class="bg-secondary inline-flex rounded-full text-white shadow dot" v-else>{{ userInfo.displayName.substring(0, 1) }}</span>
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 9rem">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="openHelp"
            >
              <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">{{ $t("Help") }}</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="defineProject"
            >
              <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">{{ $t("ChangeProject") }}</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout"
            >
              <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">{{ $t("Logout") }}</span>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
     <vs-popup class="popup" :title="$t('ChangeProject')" :active.sync="projectPopupActive">
       <vs-row style="height:200px;">
          <vs-col class="mb-15" vs-w="12">
            <form-label>{{$t('Projects')}}</form-label>
            <v-select
              ref="projectSelect"
              label="name"
              :options="projects"
              :reduce="project => project.id"
              v-model="projectId"
              @input="setSelected"
              class="w-full"
              name="projectId"
            />
          </vs-col>
       </vs-row>
    </vs-popup>
    <vs-popup class="popup" :title="$t('Help')" :active.sync="helpPopupActive">
      <div id="div-with-loading" class="vs-con-loading__container">
        <vs-row style="height:320px;">
          <vs-col class="mb-15" vs-w="12">
            <vs-row class="mb-5">
              <vs-col class="mr-5" vs-w="5">
                 <form-label>{{$t('Module')}}</form-label>
                 <v-select
                  label="name"
                  :options="modules"
                  v-model="moduleId"
                  :reduce="module => module.id"
                />
              </vs-col>
              <vs-col vs-w="6">
                <form-label>{{$t('RequestType')}}</form-label>
                <ul class="centerx">
                  <li v-for="(type, index) in helpTypes"
                    :key="index">
                    <vs-radio 
                      v-model="helpType" 
                      :vs-value="type.id">{{ $t("HelpType." + type.id) }}</vs-radio>
                  </li>
                </ul>
              </vs-col>
            </vs-row>
            <vs-row class="mb-5">
              <vs-col class="mb-15" vs-w="12">
                
                <vs-textarea class="mt-5"
                  rows="5"
                  :label="$t('HelpText')"
                  v-model="helpText"
                />
                
                <vs-button @click="submitComment" class="w-full">{{ $t('Submit') }}</vs-button>
              </vs-col>
            </vs-row>
         </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "@/app/shared/components";
import ModuleEnum  from "@/app/shared/ModuleEnum.js";
import HelpTypeEnum  from "@/app/shared/HelpTypeEnum.js";
export default {
  data() {
    return {
      user: null,
      userInfo: null,
      projectPopupActive : false,
      helpPopupActive : false,
      helpText : '',
      moduleId : 0,
      helpType : 0,
      modules: [
        { id:ModuleEnum.GradeControl, name: this.$t("ModuleEnum." + ModuleEnum.GradeControl) },
        { id:ModuleEnum.MRMR, name: this.$t("ModuleEnum." + ModuleEnum.MRMR) },
        { id:ModuleEnum.KPU, name: this.$t("ModuleEnum." + ModuleEnum.KPU) },
        { id:ModuleEnum.CashFlow, name: this.$t("ModuleEnum." + ModuleEnum.CashFlow) }
      ],
      helpTypes: [
        { id:HelpTypeEnum.Idea },
        { id:HelpTypeEnum.Issue }
      ]
    };
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  computed: {
    projects() {
      return this.$store.state.authorizedProjects;
    },
    currentProject() {
      const project = this.$store.state.authorizedProjects.filter(p => p.id === this.projectId);
      if (project.length === 0) return '';
      return project[0].name;
    },
    projectId: {
      get() {
        return this.$store.state.projectId;
      },
      set(val) {
        this.$store.dispatch("updateProjectId", val);
      }
    },
    appBootstrapCompleted() {
      return this.$store.state.appBootstrapCompleted;
    }
  },
  watch: {
    appBootstrapCompleted(val) {
      if (val) {
        this.loadUserInfo();
      }
    },
    projectPopupActive(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.projectSelect.$refs.search.focus();
        });
      }
    }
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
    defineProject() {
      this.projectPopupActive = true;
    },
    openHelp() {
      window.open("https://form.asana.com/?k=PuKNU-WOEW4owg0a--a9sg&d=32733698252827")
    },
    submitComment() {

      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      });

      const helpMessage = {
        module : this.moduleId,
        type : this.helpType,
        description : this.helpText
      };

      this.$webApi.post('help/', helpMessage).then(() => {
        this.$vs.notify({
          title: this.$t("Success"),
          text: this.$t("HelpSuccess"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
      }).finally(() => {
        this.helpPopupActive = false;
        this.$vs.loading.close('#div-with-loading > .con-vs-loading');
      });
    },
    setSelected() {
      this.projectPopupActive = false;
      window.location.reload();
    },
    loadUserInfo() {
      this.user = this.$auth.getUser();
      if (this.user !== null)
      {
        this.$graphApi.get("/me").then(response => {
          this.userInfo = response.data;
        }).catch(error => {
          console.error('Error fetching user info:', error);
          this.userInfo = {
            displayName : "N/A",
            jobTitle : "N/A"
          }
        });
      } else {
        this.userInfo = {
          displayName : "N/A",
          jobTitle : "N/A"
        }
      }
    }
  }
};
</script>

<style lang="scss">
.dot {
  height: 40px;
  width: 40px;
  font-size: 1.5rem;
  display: inline-block;
  vertical-align: middle;  
  padding-left: 13px;
  padding-top: 8px;;
  font-size: 1.5rem;
}

</style>